(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  const variantImageMap = JSON.parse(document.getElementById('variant-images-data').textContent);
  const variantSelect = document.querySelector('select[name="id"]');
  const featuredImg = document.querySelector('.product-images button:first-child img');

  variantSelect.addEventListener('change', () => {
    const src = variantImageMap[variantSelect.value];
    if (src && featuredImg) {
      featuredImg.src = src;
      featuredImg.srcset = '';
    }
  });

  const modal = document.getElementById('product-modal');
  const scrollAmount = 200;
  modal.querySelector('.left._button').addEventListener('click', () => {
    modal.querySelector('.product-modal__images').scrollBy({
      left: -scrollAmount,
      behavior: 'smooth',
    });
  });
  modal.querySelector('.right._button').addEventListener('click', () => {
    modal.querySelector('.product-modal__images').scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();
})();
